import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { IClientDocument } from "../../../models"
import ChooseClientDialogForChip from "./ChooseClientDialogForChip"
interface IProps {
	label?: string
	maxWidth?: number
	disabled?: boolean
	selectedClient?: IClientDocument
	handleSave?(client: IClientDocument): void
}
interface IState {
	selectedClient: IClientDocument
	openChooseDialog: boolean
}

export default class ChooseClientChip extends React.Component<IProps, IState>  {
	constructor(props) {
		super(props)
		this.state = {
			selectedClient: props.selectedClient,
			openChooseDialog: false,
		}
		autobind(this)
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ selectedClient: nextProps.selectedClient })
	}

	render() {
		return (
			<div>
				<div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.298)" }}>
					{this.props.label ?
						this.props.label :
						strings.Select_Client
					}
				</div>
				{this.state.selectedClient &&
					<Chip
						data-intercom-target={"Select-Client"}
						style={{ margin: 2, height: 35, width: "min-content" }}
						onRequestDelete={this.props.disabled ?
							null :
							() => {
								this.setState({ selectedClient: null })
								this.props.handleSave &&
									this.props.handleSave(null)
							}
						}
					>
						<div
							className="TextOverflow"
							title={this.state.selectedClient.Name}
							style={{ maxWidth: this.props.maxWidth ? this.props.disabled ? this.props.maxWidth : this.props.maxWidth - 25 : 150 }}
						>
							{this.state.selectedClient.Name}
						</div>
					</Chip>
				}
				{!this.state.selectedClient &&
					<IconButton
						data-intercom-target={"Client-Btn-OpenClientSelectionDialog"}
						style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
						onTouchTap={this.props.disabled ? null : () => this.setState({ openChooseDialog: true })}
						disabled={this.props.disabled}
					>
						<FontIcon className="fa fa-plus-circle" />
					</IconButton>
				}
				{this.state.openChooseDialog &&
					<ChooseClientDialogForChip
						handleClose={() => this.setState({ openChooseDialog: false })}
						handleSave={selectedClient => {
							this.setState({
								selectedClient,
								openChooseDialog: false
							})
							this.props.handleSave &&
								this.props.handleSave(selectedClient)
						}}
					/>
				}
			</div>
		)
	}
}
